import React from 'react';

import { Skeleton, Stack } from '@mui/material';
import PropTypes from 'prop-types';

import { COLOR_PALETTE } from 'constants/ui';

import { FunctionIconSize, IconSizeMap } from './FunctionIcon.constants';
import { getIconWrapperStyles, skeletonStyles } from './FunctionIcon.styles';
import { FunctionIconTestIds } from './FunctionIcon.testIds';

const FunctionIcon = ({
  children: icon,
  iconSize = FunctionIconSize.SMALL,
  iconColor = COLOR_PALETTE.BLUE[2],
  isLoading = false,
}) =>
  isLoading ? (
    <Skeleton
      height={IconSizeMap[iconSize]}
      sx={skeletonStyles}
      variant="circular"
      width={IconSizeMap[iconSize]}
    />
  ) : (
    <Stack
      data-testid={FunctionIconTestIds.FUNCTION_ICON}
      sx={getIconWrapperStyles({ iconColor, iconSize })}
    >
      {icon}
    </Stack>
  );

FunctionIcon.propTypes = {
  children: PropTypes.node,
  iconSize: PropTypes.oneOf(Object.values(FunctionIconSize)),
  iconColor: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default FunctionIcon;
